'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requirementDataActions = require('actions/requirementDataActions');

// requirements are stored by hash
function requirements() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _requirementDataActions.REQUIREMENT_DATA_RECEIVED:
            return action.requirementData.requirements;
        default:
            return state;
    }
}

exports.default = requirements;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/requirements.js
// module id = 1403
// module chunks = 0